import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import en from './en'
import fr from './fr'
import es from './es'
import it from './it'
import pt from './pt'
import nl from './nl'
import ru from './ru'
import pl from './pl'
import sv from './sv'

const STORAGE_KEY = 'nm_locale'

function detectLocale(): string {
  if (typeof localStorage !== 'undefined') {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved) return saved
  }

  if (typeof navigator !== 'undefined') {
    const browserLang = (navigator.language || '').toLowerCase()
    const supportedLocales = [
      'zh-cn', 'en', 'fr', 'es', 'it', 'pt', 'nl', 'ru', 'pl', 'sv',
    ]
    if (supportedLocales.includes(browserLang)) return browserLang
    const prefix = browserLang.split('-')[0]
    const match = supportedLocales.find(l => l.startsWith(prefix))
    if (match) return match
  }

  return 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: {
    'zh-CN': zhCN,
    en,
    fr,
    es,
    it,
    pt,
    nl,
    ru,
    pl,
    sv,
  },
})

export default i18n
